import { useNavigate } from "react-router-dom";
import "./not_found.css";
import { Helmet } from "react-helmet";

function Unauthorized() {
    const navigator = useNavigate();
    return (
        <div className="not-found">
            <Helmet>
                <title>Access Unauthorized</title>
            </Helmet>
            <h1>Unauthorized</h1>
            <p className="zoom-area">The page you looking for can not be opened becouse your are <b>Unauthorized</b> to access this.</p>
            <div className="link-container">
                <span onClick={() => { navigator("/dashboard"); }} style={{ cursor: "pointer" }} className="more-link">Home Page</span>
            </div>
        </div>
    );
}

export default Unauthorized;